import { MINIMUM_INPUT_LENGTH, MINIMUM_QUERY_LENGTH } from '../constants'
import { resetIsCompleteTickIcon } from '../helpers'
import { fetchBusinessNumber } from './fetch-business-number'

/**
 * This function performs an API call to the ABN Lookup using a Text Based Search
 */
export const TextBasedSearch = (query, elements, validate) => {
  const { ABNInput, ABNTextSearchInput, next: navigationNextButton } = elements
  const isGreaterThanQueryMinimum = query && query.length > MINIMUM_QUERY_LENGTH
  const hasPassedMinimumQueryLength =
    query && query.length >= MINIMUM_QUERY_LENGTH

  if (isGreaterThanQueryMinimum) {
    resetIsCompleteTickIcon(ABNInput, ABNTextSearchInput)
  }

  const valueNumb = query.replace(/\s+/g, ``)
  const queryCheck = validate(
    { duration: valueNumb },
    { duration: { numericality: true } }
  )

  if (!queryCheck) {
    query = valueNumb
  }
  if (hasPassedMinimumQueryLength) {
    fetchBusinessNumber(query, elements, `name`)
  } else {
    document
      .getElementById(`ABNTextSearchErrorMessage`)
      .classList.add(`highlight-error`)
    navigationNextButton.classList.add(`disabled`)
  }
}
